/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SitemapRouteRouteImport } from './routes/sitemap/route'
import { Route as ServicesRouteRouteImport } from './routes/services/route'
import { Route as FeedbackRouteRouteImport } from './routes/feedback/route'
import { Route as FaqRouteRouteImport } from './routes/faq/route'
import { Route as ContactUsRouteRouteImport } from './routes/contact-us/route'
import { Route as AccessibilityRouteRouteImport } from './routes/accessibility/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ZonesIndexRouteImport } from './routes/zones/index'
import { Route as VerifyEmailIndexRouteImport } from './routes/verify-email/index'
import { Route as SitemapIndexRouteImport } from './routes/sitemap/index'
import { Route as SignupIndexRouteImport } from './routes/signup/index'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as ForgotPasswordIndexRouteImport } from './routes/forgot-password/index'
import { Route as FeedbackIndexRouteImport } from './routes/feedback/index'
import { Route as FaqIndexRouteImport } from './routes/faq/index'
import { Route as ContactUsIndexRouteImport } from './routes/contact-us/index'
import { Route as AccessibilityIndexRouteImport } from './routes/accessibility/index'
import { Route as AboutUsIndexRouteImport } from './routes/about-us/index'
import { Route as ServicesServicesCatalogueRouteRouteImport } from './routes/services/services-catalogue/route'
import { Route as AuthRegistryRouteRouteImport } from './routes/_auth/registry/route'
import { Route as AuthProfileRouteRouteImport } from './routes/_auth/profile/route'
import { Route as AuthProcessesRouteRouteImport } from './routes/_auth/processes/route'
import { Route as AuthDashboardRouteRouteImport } from './routes/_auth/dashboard/route'
import { Route as ServicesServicesCatalogueIndexRouteImport } from './routes/services/services-catalogue/index'
import { Route as AuthTasksIndexRouteImport } from './routes/_auth/tasks/index'
import { Route as AuthStartServiceIndexRouteImport } from './routes/_auth/start-service/index'
import { Route as AuthProcessesIndexRouteImport } from './routes/_auth/processes/index'
import { Route as AuthLogoutIndexRouteImport } from './routes/_auth/logout/index'
import { Route as AuthChatBotIndexRouteImport } from './routes/_auth/chat-bot/index'
import { Route as ServicesServicesCatalogueIdRouteImport } from './routes/services/services-catalogue/$id'
import { Route as AuthDashboardLayoutRouteImport } from './routes/_auth/dashboard/_layout'
import { Route as AuthRegistryServiceProvidersRouteRouteImport } from './routes/_auth/registry/service-providers/route'
import { Route as AuthRegistryRentalContractsRouteRouteImport } from './routes/_auth/registry/rental-contracts/route'
import { Route as AuthRegistryPropertiesRouteRouteImport } from './routes/_auth/registry/properties/route'
import { Route as AuthRegistryPermitsRouteRouteImport } from './routes/_auth/registry/permits/route'
import { Route as AuthRegistryContractsRouteRouteImport } from './routes/_auth/registry/contracts/route'
import { Route as AuthProcessesProcessInstanceIdIndexRouteImport } from './routes/_auth/processes/$processInstanceId/index'
import { Route as AuthDashboardLayoutIndexRouteImport } from './routes/_auth/dashboard/_layout.index'
import { Route as AuthProfileInvestorLayoutRouteImport } from './routes/_auth/profile/investor/_layout'
import { Route as AuthProfileCompanyLayoutRouteImport } from './routes/_auth/profile/company/_layout'
import { Route as AuthDashboardLayoutWorkflowsRouteImport } from './routes/_auth/dashboard/_layout.workflows'
import { Route as AuthDashboardLayoutServiceProvidersRouteImport } from './routes/_auth/dashboard/_layout.service-providers'
import { Route as AuthDashboardLayoutRentalContractsRouteImport } from './routes/_auth/dashboard/_layout.rental-contracts'
import { Route as AuthDashboardLayoutPropertiesRouteImport } from './routes/_auth/dashboard/_layout.properties'
import { Route as AuthDashboardLayoutPermitsRouteImport } from './routes/_auth/dashboard/_layout.permits'
import { Route as AuthDashboardLayoutContractsRouteImport } from './routes/_auth/dashboard/_layout.contracts'
import { Route as AuthRegistryServiceProvidersProviderIdIndexRouteImport } from './routes/_auth/registry/service-providers/$providerId/index'
import { Route as AuthRegistryRentalContractsRentalContractIdIndexRouteImport } from './routes/_auth/registry/rental-contracts/$rentalContractId/index'
import { Route as AuthRegistryPropertiesPropertyIdIndexRouteImport } from './routes/_auth/registry/properties/$propertyId/index'
import { Route as AuthRegistryPermitsPermitIdIndexRouteImport } from './routes/_auth/registry/permits/$permitId/index'
import { Route as AuthRegistryContractsContractIdIndexRouteImport } from './routes/_auth/registry/contracts/$contractId/index'
import { Route as AuthProfileInvestorLayoutIndexRouteImport } from './routes/_auth/profile/investor/_layout.index'
import { Route as AuthProfileCompanyLayoutIndexRouteImport } from './routes/_auth/profile/company/_layout.index'
import { Route as AuthProfileInvestorLayoutPersonalInformationRouteImport } from './routes/_auth/profile/investor/_layout.personal-information'
import { Route as AuthProfileInvestorLayoutNotificationSettingsRouteImport } from './routes/_auth/profile/investor/_layout.notification-settings'
import { Route as AuthProfileCompanyLayoutRepresentativesRouteImport } from './routes/_auth/profile/company/_layout.representatives'
import { Route as AuthProfileCompanyLayoutNotificationSettingsRouteImport } from './routes/_auth/profile/company/_layout.notification-settings'
import { Route as AuthProfileCompanyLayoutCrInformationRouteImport } from './routes/_auth/profile/company/_layout.cr-information'
import { Route as AuthProfileCompanyRepresentativeRepresentativeIdIndexRouteImport } from './routes/_auth/profile/company/representative/$representativeId/index'
import { Route as AuthProcessesProcessInstanceIdTaskTaskIdIndexRouteImport } from './routes/_auth/processes/$processInstanceId/task/$taskId/index'
import { Route as AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRouteImport } from './routes/_auth/processes/$processInstanceId/task/$taskId/payment/index'

const SitemapRouteRoute = SitemapRouteRouteImport.update({
  id: '/sitemap',
  path: '/sitemap',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesRouteRoute = ServicesRouteRouteImport.update({
  id: '/services',
  path: '/services',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackRouteRoute = FeedbackRouteRouteImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRouteRoute = FaqRouteRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRouteRoute = ContactUsRouteRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const AccessibilityRouteRoute = AccessibilityRouteRouteImport.update({
  id: '/accessibility',
  path: '/accessibility',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ZonesIndexRoute = ZonesIndexRouteImport.update({
  id: '/zones/',
  path: '/zones/',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailIndexRoute = VerifyEmailIndexRouteImport.update({
  id: '/verify-email/',
  path: '/verify-email/',
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapIndexRoute = SitemapIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SitemapRouteRoute,
} as any)
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: '/signup/',
  path: '/signup/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesIndexRoute = ServicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ServicesRouteRoute,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordIndexRoute = ForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeedbackIndexRoute = FeedbackIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FeedbackRouteRoute,
} as any)
const FaqIndexRoute = FaqIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FaqRouteRoute,
} as any)
const ContactUsIndexRoute = ContactUsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ContactUsRouteRoute,
} as any)
const AccessibilityIndexRoute = AccessibilityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccessibilityRouteRoute,
} as any)
const AboutUsIndexRoute = AboutUsIndexRouteImport.update({
  id: '/about-us/',
  path: '/about-us/',
  getParentRoute: () => rootRouteImport,
} as any)
const ServicesServicesCatalogueRouteRoute =
  ServicesServicesCatalogueRouteRouteImport.update({
    id: '/services-catalogue',
    path: '/services-catalogue',
    getParentRoute: () => ServicesRouteRoute,
  } as any)
const AuthRegistryRouteRoute = AuthRegistryRouteRouteImport.update({
  id: '/registry',
  path: '/registry',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthProfileRouteRoute = AuthProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthProcessesRouteRoute = AuthProcessesRouteRouteImport.update({
  id: '/processes',
  path: '/processes',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthDashboardRouteRoute = AuthDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ServicesServicesCatalogueIndexRoute =
  ServicesServicesCatalogueIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ServicesServicesCatalogueRouteRoute,
  } as any)
const AuthTasksIndexRoute = AuthTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthStartServiceIndexRoute = AuthStartServiceIndexRouteImport.update({
  id: '/start-service/',
  path: '/start-service/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthProcessesIndexRoute = AuthProcessesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthProcessesRouteRoute,
} as any)
const AuthLogoutIndexRoute = AuthLogoutIndexRouteImport.update({
  id: '/logout/',
  path: '/logout/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthChatBotIndexRoute = AuthChatBotIndexRouteImport.update({
  id: '/chat-bot/',
  path: '/chat-bot/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ServicesServicesCatalogueIdRoute =
  ServicesServicesCatalogueIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => ServicesServicesCatalogueRouteRoute,
  } as any)
const AuthDashboardLayoutRoute = AuthDashboardLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => AuthDashboardRouteRoute,
} as any)
const AuthRegistryServiceProvidersRouteRoute =
  AuthRegistryServiceProvidersRouteRouteImport.update({
    id: '/service-providers',
    path: '/service-providers',
    getParentRoute: () => AuthRegistryRouteRoute,
  } as any)
const AuthRegistryRentalContractsRouteRoute =
  AuthRegistryRentalContractsRouteRouteImport.update({
    id: '/rental-contracts',
    path: '/rental-contracts',
    getParentRoute: () => AuthRegistryRouteRoute,
  } as any)
const AuthRegistryPropertiesRouteRoute =
  AuthRegistryPropertiesRouteRouteImport.update({
    id: '/properties',
    path: '/properties',
    getParentRoute: () => AuthRegistryRouteRoute,
  } as any)
const AuthRegistryPermitsRouteRoute =
  AuthRegistryPermitsRouteRouteImport.update({
    id: '/permits',
    path: '/permits',
    getParentRoute: () => AuthRegistryRouteRoute,
  } as any)
const AuthRegistryContractsRouteRoute =
  AuthRegistryContractsRouteRouteImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => AuthRegistryRouteRoute,
  } as any)
const AuthProcessesProcessInstanceIdIndexRoute =
  AuthProcessesProcessInstanceIdIndexRouteImport.update({
    id: '/$processInstanceId/',
    path: '/$processInstanceId/',
    getParentRoute: () => AuthProcessesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/processes/$processInstanceId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthDashboardLayoutIndexRoute =
  AuthDashboardLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthDashboardLayoutRoute,
  } as any)
const AuthProfileInvestorLayoutRoute =
  AuthProfileInvestorLayoutRouteImport.update({
    id: '/investor/_layout',
    path: '/investor',
    getParentRoute: () => AuthProfileRouteRoute,
  } as any)
const AuthProfileCompanyLayoutRoute =
  AuthProfileCompanyLayoutRouteImport.update({
    id: '/company/_layout',
    path: '/company',
    getParentRoute: () => AuthProfileRouteRoute,
  } as any)
const AuthDashboardLayoutWorkflowsRoute =
  AuthDashboardLayoutWorkflowsRouteImport.update({
    id: '/workflows',
    path: '/workflows',
    getParentRoute: () => AuthDashboardLayoutRoute,
  } as any)
const AuthDashboardLayoutServiceProvidersRoute =
  AuthDashboardLayoutServiceProvidersRouteImport.update({
    id: '/service-providers',
    path: '/service-providers',
    getParentRoute: () => AuthDashboardLayoutRoute,
  } as any)
const AuthDashboardLayoutRentalContractsRoute =
  AuthDashboardLayoutRentalContractsRouteImport.update({
    id: '/rental-contracts',
    path: '/rental-contracts',
    getParentRoute: () => AuthDashboardLayoutRoute,
  } as any)
const AuthDashboardLayoutPropertiesRoute =
  AuthDashboardLayoutPropertiesRouteImport.update({
    id: '/properties',
    path: '/properties',
    getParentRoute: () => AuthDashboardLayoutRoute,
  } as any)
const AuthDashboardLayoutPermitsRoute =
  AuthDashboardLayoutPermitsRouteImport.update({
    id: '/permits',
    path: '/permits',
    getParentRoute: () => AuthDashboardLayoutRoute,
  } as any)
const AuthDashboardLayoutContractsRoute =
  AuthDashboardLayoutContractsRouteImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => AuthDashboardLayoutRoute,
  } as any)
const AuthRegistryServiceProvidersProviderIdIndexRoute =
  AuthRegistryServiceProvidersProviderIdIndexRouteImport.update({
    id: '/$providerId/',
    path: '/$providerId/',
    getParentRoute: () => AuthRegistryServiceProvidersRouteRoute,
  } as any)
const AuthRegistryRentalContractsRentalContractIdIndexRoute =
  AuthRegistryRentalContractsRentalContractIdIndexRouteImport.update({
    id: '/$rentalContractId/',
    path: '/$rentalContractId/',
    getParentRoute: () => AuthRegistryRentalContractsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/registry/rental-contracts/$rentalContractId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthRegistryPropertiesPropertyIdIndexRoute =
  AuthRegistryPropertiesPropertyIdIndexRouteImport.update({
    id: '/$propertyId/',
    path: '/$propertyId/',
    getParentRoute: () => AuthRegistryPropertiesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/registry/properties/$propertyId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthRegistryPermitsPermitIdIndexRoute =
  AuthRegistryPermitsPermitIdIndexRouteImport.update({
    id: '/$permitId/',
    path: '/$permitId/',
    getParentRoute: () => AuthRegistryPermitsRouteRoute,
  } as any)
const AuthRegistryContractsContractIdIndexRoute =
  AuthRegistryContractsContractIdIndexRouteImport.update({
    id: '/$contractId/',
    path: '/$contractId/',
    getParentRoute: () => AuthRegistryContractsRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/registry/contracts/$contractId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthProfileInvestorLayoutIndexRoute =
  AuthProfileInvestorLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthProfileInvestorLayoutRoute,
  } as any)
const AuthProfileCompanyLayoutIndexRoute =
  AuthProfileCompanyLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthProfileCompanyLayoutRoute,
  } as any)
const AuthProfileInvestorLayoutPersonalInformationRoute =
  AuthProfileInvestorLayoutPersonalInformationRouteImport.update({
    id: '/personal-information',
    path: '/personal-information',
    getParentRoute: () => AuthProfileInvestorLayoutRoute,
  } as any)
const AuthProfileInvestorLayoutNotificationSettingsRoute =
  AuthProfileInvestorLayoutNotificationSettingsRouteImport.update({
    id: '/notification-settings',
    path: '/notification-settings',
    getParentRoute: () => AuthProfileInvestorLayoutRoute,
  } as any)
const AuthProfileCompanyLayoutRepresentativesRoute =
  AuthProfileCompanyLayoutRepresentativesRouteImport.update({
    id: '/representatives',
    path: '/representatives',
    getParentRoute: () => AuthProfileCompanyLayoutRoute,
  } as any)
const AuthProfileCompanyLayoutNotificationSettingsRoute =
  AuthProfileCompanyLayoutNotificationSettingsRouteImport.update({
    id: '/notification-settings',
    path: '/notification-settings',
    getParentRoute: () => AuthProfileCompanyLayoutRoute,
  } as any)
const AuthProfileCompanyLayoutCrInformationRoute =
  AuthProfileCompanyLayoutCrInformationRouteImport.update({
    id: '/cr-information',
    path: '/cr-information',
    getParentRoute: () => AuthProfileCompanyLayoutRoute,
  } as any)
const AuthProfileCompanyRepresentativeRepresentativeIdIndexRoute =
  AuthProfileCompanyRepresentativeRepresentativeIdIndexRouteImport.update({
    id: '/company/representative/$representativeId/',
    path: '/company/representative/$representativeId/',
    getParentRoute: () => AuthProfileRouteRoute,
  } as any)
const AuthProcessesProcessInstanceIdTaskTaskIdIndexRoute =
  AuthProcessesProcessInstanceIdTaskTaskIdIndexRouteImport.update({
    id: '/$processInstanceId/task/$taskId/',
    path: '/$processInstanceId/task/$taskId/',
    getParentRoute: () => AuthProcessesRouteRoute,
  } as any).lazy(() =>
    import('./routes/_auth/processes/$processInstanceId/task/$taskId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRoute =
  AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRouteImport.update({
    id: '/$processInstanceId/task/$taskId/payment/',
    path: '/$processInstanceId/task/$taskId/payment/',
    getParentRoute: () => AuthProcessesRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accessibility': typeof AccessibilityRouteRouteWithChildren
  '/contact-us': typeof ContactUsRouteRouteWithChildren
  '/faq': typeof FaqRouteRouteWithChildren
  '/feedback': typeof FeedbackRouteRouteWithChildren
  '/services': typeof ServicesRouteRouteWithChildren
  '/sitemap': typeof SitemapRouteRouteWithChildren
  '/dashboard': typeof AuthDashboardLayoutRouteWithChildren
  '/processes': typeof AuthProcessesRouteRouteWithChildren
  '/profile': typeof AuthProfileRouteRouteWithChildren
  '/registry': typeof AuthRegistryRouteRouteWithChildren
  '/services/services-catalogue': typeof ServicesServicesCatalogueRouteRouteWithChildren
  '/about-us/': typeof AboutUsIndexRoute
  '/accessibility/': typeof AccessibilityIndexRoute
  '/contact-us/': typeof ContactUsIndexRoute
  '/faq/': typeof FaqIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/login/': typeof LoginIndexRoute
  '/services/': typeof ServicesIndexRoute
  '/signup/': typeof SignupIndexRoute
  '/sitemap/': typeof SitemapIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/zones/': typeof ZonesIndexRoute
  '/registry/contracts': typeof AuthRegistryContractsRouteRouteWithChildren
  '/registry/permits': typeof AuthRegistryPermitsRouteRouteWithChildren
  '/registry/properties': typeof AuthRegistryPropertiesRouteRouteWithChildren
  '/registry/rental-contracts': typeof AuthRegistryRentalContractsRouteRouteWithChildren
  '/registry/service-providers': typeof AuthRegistryServiceProvidersRouteRouteWithChildren
  '/services/services-catalogue/$id': typeof ServicesServicesCatalogueIdRoute
  '/chat-bot/': typeof AuthChatBotIndexRoute
  '/logout/': typeof AuthLogoutIndexRoute
  '/processes/': typeof AuthProcessesIndexRoute
  '/start-service/': typeof AuthStartServiceIndexRoute
  '/tasks/': typeof AuthTasksIndexRoute
  '/services/services-catalogue/': typeof ServicesServicesCatalogueIndexRoute
  '/dashboard/contracts': typeof AuthDashboardLayoutContractsRoute
  '/dashboard/permits': typeof AuthDashboardLayoutPermitsRoute
  '/dashboard/properties': typeof AuthDashboardLayoutPropertiesRoute
  '/dashboard/rental-contracts': typeof AuthDashboardLayoutRentalContractsRoute
  '/dashboard/service-providers': typeof AuthDashboardLayoutServiceProvidersRoute
  '/dashboard/workflows': typeof AuthDashboardLayoutWorkflowsRoute
  '/profile/company': typeof AuthProfileCompanyLayoutRouteWithChildren
  '/profile/investor': typeof AuthProfileInvestorLayoutRouteWithChildren
  '/dashboard/': typeof AuthDashboardLayoutIndexRoute
  '/processes/$processInstanceId/': typeof AuthProcessesProcessInstanceIdIndexRoute
  '/profile/company/cr-information': typeof AuthProfileCompanyLayoutCrInformationRoute
  '/profile/company/notification-settings': typeof AuthProfileCompanyLayoutNotificationSettingsRoute
  '/profile/company/representatives': typeof AuthProfileCompanyLayoutRepresentativesRoute
  '/profile/investor/notification-settings': typeof AuthProfileInvestorLayoutNotificationSettingsRoute
  '/profile/investor/personal-information': typeof AuthProfileInvestorLayoutPersonalInformationRoute
  '/profile/company/': typeof AuthProfileCompanyLayoutIndexRoute
  '/profile/investor/': typeof AuthProfileInvestorLayoutIndexRoute
  '/registry/contracts/$contractId/': typeof AuthRegistryContractsContractIdIndexRoute
  '/registry/permits/$permitId/': typeof AuthRegistryPermitsPermitIdIndexRoute
  '/registry/properties/$propertyId/': typeof AuthRegistryPropertiesPropertyIdIndexRoute
  '/registry/rental-contracts/$rentalContractId/': typeof AuthRegistryRentalContractsRentalContractIdIndexRoute
  '/registry/service-providers/$providerId/': typeof AuthRegistryServiceProvidersProviderIdIndexRoute
  '/processes/$processInstanceId/task/$taskId/': typeof AuthProcessesProcessInstanceIdTaskTaskIdIndexRoute
  '/profile/company/representative/$representativeId/': typeof AuthProfileCompanyRepresentativeRepresentativeIdIndexRoute
  '/processes/$processInstanceId/task/$taskId/payment/': typeof AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AuthDashboardLayoutIndexRoute
  '/profile': typeof AuthProfileRouteRouteWithChildren
  '/registry': typeof AuthRegistryRouteRouteWithChildren
  '/about-us': typeof AboutUsIndexRoute
  '/accessibility': typeof AccessibilityIndexRoute
  '/contact-us': typeof ContactUsIndexRoute
  '/faq': typeof FaqIndexRoute
  '/feedback': typeof FeedbackIndexRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/services': typeof ServicesIndexRoute
  '/signup': typeof SignupIndexRoute
  '/sitemap': typeof SitemapIndexRoute
  '/verify-email': typeof VerifyEmailIndexRoute
  '/zones': typeof ZonesIndexRoute
  '/registry/contracts': typeof AuthRegistryContractsRouteRouteWithChildren
  '/registry/permits': typeof AuthRegistryPermitsRouteRouteWithChildren
  '/registry/properties': typeof AuthRegistryPropertiesRouteRouteWithChildren
  '/registry/rental-contracts': typeof AuthRegistryRentalContractsRouteRouteWithChildren
  '/registry/service-providers': typeof AuthRegistryServiceProvidersRouteRouteWithChildren
  '/services/services-catalogue/$id': typeof ServicesServicesCatalogueIdRoute
  '/chat-bot': typeof AuthChatBotIndexRoute
  '/logout': typeof AuthLogoutIndexRoute
  '/processes': typeof AuthProcessesIndexRoute
  '/start-service': typeof AuthStartServiceIndexRoute
  '/tasks': typeof AuthTasksIndexRoute
  '/services/services-catalogue': typeof ServicesServicesCatalogueIndexRoute
  '/dashboard/contracts': typeof AuthDashboardLayoutContractsRoute
  '/dashboard/permits': typeof AuthDashboardLayoutPermitsRoute
  '/dashboard/properties': typeof AuthDashboardLayoutPropertiesRoute
  '/dashboard/rental-contracts': typeof AuthDashboardLayoutRentalContractsRoute
  '/dashboard/service-providers': typeof AuthDashboardLayoutServiceProvidersRoute
  '/dashboard/workflows': typeof AuthDashboardLayoutWorkflowsRoute
  '/processes/$processInstanceId': typeof AuthProcessesProcessInstanceIdIndexRoute
  '/profile/company/cr-information': typeof AuthProfileCompanyLayoutCrInformationRoute
  '/profile/company/notification-settings': typeof AuthProfileCompanyLayoutNotificationSettingsRoute
  '/profile/company/representatives': typeof AuthProfileCompanyLayoutRepresentativesRoute
  '/profile/investor/notification-settings': typeof AuthProfileInvestorLayoutNotificationSettingsRoute
  '/profile/investor/personal-information': typeof AuthProfileInvestorLayoutPersonalInformationRoute
  '/profile/company': typeof AuthProfileCompanyLayoutIndexRoute
  '/profile/investor': typeof AuthProfileInvestorLayoutIndexRoute
  '/registry/contracts/$contractId': typeof AuthRegistryContractsContractIdIndexRoute
  '/registry/permits/$permitId': typeof AuthRegistryPermitsPermitIdIndexRoute
  '/registry/properties/$propertyId': typeof AuthRegistryPropertiesPropertyIdIndexRoute
  '/registry/rental-contracts/$rentalContractId': typeof AuthRegistryRentalContractsRentalContractIdIndexRoute
  '/registry/service-providers/$providerId': typeof AuthRegistryServiceProvidersProviderIdIndexRoute
  '/processes/$processInstanceId/task/$taskId': typeof AuthProcessesProcessInstanceIdTaskTaskIdIndexRoute
  '/profile/company/representative/$representativeId': typeof AuthProfileCompanyRepresentativeRepresentativeIdIndexRoute
  '/processes/$processInstanceId/task/$taskId/payment': typeof AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/accessibility': typeof AccessibilityRouteRouteWithChildren
  '/contact-us': typeof ContactUsRouteRouteWithChildren
  '/faq': typeof FaqRouteRouteWithChildren
  '/feedback': typeof FeedbackRouteRouteWithChildren
  '/services': typeof ServicesRouteRouteWithChildren
  '/sitemap': typeof SitemapRouteRouteWithChildren
  '/_auth/dashboard': typeof AuthDashboardRouteRouteWithChildren
  '/_auth/processes': typeof AuthProcessesRouteRouteWithChildren
  '/_auth/profile': typeof AuthProfileRouteRouteWithChildren
  '/_auth/registry': typeof AuthRegistryRouteRouteWithChildren
  '/services/services-catalogue': typeof ServicesServicesCatalogueRouteRouteWithChildren
  '/about-us/': typeof AboutUsIndexRoute
  '/accessibility/': typeof AccessibilityIndexRoute
  '/contact-us/': typeof ContactUsIndexRoute
  '/faq/': typeof FaqIndexRoute
  '/feedback/': typeof FeedbackIndexRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/login/': typeof LoginIndexRoute
  '/services/': typeof ServicesIndexRoute
  '/signup/': typeof SignupIndexRoute
  '/sitemap/': typeof SitemapIndexRoute
  '/verify-email/': typeof VerifyEmailIndexRoute
  '/zones/': typeof ZonesIndexRoute
  '/_auth/registry/contracts': typeof AuthRegistryContractsRouteRouteWithChildren
  '/_auth/registry/permits': typeof AuthRegistryPermitsRouteRouteWithChildren
  '/_auth/registry/properties': typeof AuthRegistryPropertiesRouteRouteWithChildren
  '/_auth/registry/rental-contracts': typeof AuthRegistryRentalContractsRouteRouteWithChildren
  '/_auth/registry/service-providers': typeof AuthRegistryServiceProvidersRouteRouteWithChildren
  '/_auth/dashboard/_layout': typeof AuthDashboardLayoutRouteWithChildren
  '/services/services-catalogue/$id': typeof ServicesServicesCatalogueIdRoute
  '/_auth/chat-bot/': typeof AuthChatBotIndexRoute
  '/_auth/logout/': typeof AuthLogoutIndexRoute
  '/_auth/processes/': typeof AuthProcessesIndexRoute
  '/_auth/start-service/': typeof AuthStartServiceIndexRoute
  '/_auth/tasks/': typeof AuthTasksIndexRoute
  '/services/services-catalogue/': typeof ServicesServicesCatalogueIndexRoute
  '/_auth/dashboard/_layout/contracts': typeof AuthDashboardLayoutContractsRoute
  '/_auth/dashboard/_layout/permits': typeof AuthDashboardLayoutPermitsRoute
  '/_auth/dashboard/_layout/properties': typeof AuthDashboardLayoutPropertiesRoute
  '/_auth/dashboard/_layout/rental-contracts': typeof AuthDashboardLayoutRentalContractsRoute
  '/_auth/dashboard/_layout/service-providers': typeof AuthDashboardLayoutServiceProvidersRoute
  '/_auth/dashboard/_layout/workflows': typeof AuthDashboardLayoutWorkflowsRoute
  '/_auth/profile/company/_layout': typeof AuthProfileCompanyLayoutRouteWithChildren
  '/_auth/profile/investor/_layout': typeof AuthProfileInvestorLayoutRouteWithChildren
  '/_auth/dashboard/_layout/': typeof AuthDashboardLayoutIndexRoute
  '/_auth/processes/$processInstanceId/': typeof AuthProcessesProcessInstanceIdIndexRoute
  '/_auth/profile/company/_layout/cr-information': typeof AuthProfileCompanyLayoutCrInformationRoute
  '/_auth/profile/company/_layout/notification-settings': typeof AuthProfileCompanyLayoutNotificationSettingsRoute
  '/_auth/profile/company/_layout/representatives': typeof AuthProfileCompanyLayoutRepresentativesRoute
  '/_auth/profile/investor/_layout/notification-settings': typeof AuthProfileInvestorLayoutNotificationSettingsRoute
  '/_auth/profile/investor/_layout/personal-information': typeof AuthProfileInvestorLayoutPersonalInformationRoute
  '/_auth/profile/company/_layout/': typeof AuthProfileCompanyLayoutIndexRoute
  '/_auth/profile/investor/_layout/': typeof AuthProfileInvestorLayoutIndexRoute
  '/_auth/registry/contracts/$contractId/': typeof AuthRegistryContractsContractIdIndexRoute
  '/_auth/registry/permits/$permitId/': typeof AuthRegistryPermitsPermitIdIndexRoute
  '/_auth/registry/properties/$propertyId/': typeof AuthRegistryPropertiesPropertyIdIndexRoute
  '/_auth/registry/rental-contracts/$rentalContractId/': typeof AuthRegistryRentalContractsRentalContractIdIndexRoute
  '/_auth/registry/service-providers/$providerId/': typeof AuthRegistryServiceProvidersProviderIdIndexRoute
  '/_auth/processes/$processInstanceId/task/$taskId/': typeof AuthProcessesProcessInstanceIdTaskTaskIdIndexRoute
  '/_auth/profile/company/representative/$representativeId/': typeof AuthProfileCompanyRepresentativeRepresentativeIdIndexRoute
  '/_auth/processes/$processInstanceId/task/$taskId/payment/': typeof AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accessibility'
    | '/contact-us'
    | '/faq'
    | '/feedback'
    | '/services'
    | '/sitemap'
    | '/dashboard'
    | '/processes'
    | '/profile'
    | '/registry'
    | '/services/services-catalogue'
    | '/about-us/'
    | '/accessibility/'
    | '/contact-us/'
    | '/faq/'
    | '/feedback/'
    | '/forgot-password/'
    | '/login/'
    | '/services/'
    | '/signup/'
    | '/sitemap/'
    | '/verify-email/'
    | '/zones/'
    | '/registry/contracts'
    | '/registry/permits'
    | '/registry/properties'
    | '/registry/rental-contracts'
    | '/registry/service-providers'
    | '/services/services-catalogue/$id'
    | '/chat-bot/'
    | '/logout/'
    | '/processes/'
    | '/start-service/'
    | '/tasks/'
    | '/services/services-catalogue/'
    | '/dashboard/contracts'
    | '/dashboard/permits'
    | '/dashboard/properties'
    | '/dashboard/rental-contracts'
    | '/dashboard/service-providers'
    | '/dashboard/workflows'
    | '/profile/company'
    | '/profile/investor'
    | '/dashboard/'
    | '/processes/$processInstanceId/'
    | '/profile/company/cr-information'
    | '/profile/company/notification-settings'
    | '/profile/company/representatives'
    | '/profile/investor/notification-settings'
    | '/profile/investor/personal-information'
    | '/profile/company/'
    | '/profile/investor/'
    | '/registry/contracts/$contractId/'
    | '/registry/permits/$permitId/'
    | '/registry/properties/$propertyId/'
    | '/registry/rental-contracts/$rentalContractId/'
    | '/registry/service-providers/$providerId/'
    | '/processes/$processInstanceId/task/$taskId/'
    | '/profile/company/representative/$representativeId/'
    | '/processes/$processInstanceId/task/$taskId/payment/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/profile'
    | '/registry'
    | '/about-us'
    | '/accessibility'
    | '/contact-us'
    | '/faq'
    | '/feedback'
    | '/forgot-password'
    | '/login'
    | '/services'
    | '/signup'
    | '/sitemap'
    | '/verify-email'
    | '/zones'
    | '/registry/contracts'
    | '/registry/permits'
    | '/registry/properties'
    | '/registry/rental-contracts'
    | '/registry/service-providers'
    | '/services/services-catalogue/$id'
    | '/chat-bot'
    | '/logout'
    | '/processes'
    | '/start-service'
    | '/tasks'
    | '/services/services-catalogue'
    | '/dashboard/contracts'
    | '/dashboard/permits'
    | '/dashboard/properties'
    | '/dashboard/rental-contracts'
    | '/dashboard/service-providers'
    | '/dashboard/workflows'
    | '/processes/$processInstanceId'
    | '/profile/company/cr-information'
    | '/profile/company/notification-settings'
    | '/profile/company/representatives'
    | '/profile/investor/notification-settings'
    | '/profile/investor/personal-information'
    | '/profile/company'
    | '/profile/investor'
    | '/registry/contracts/$contractId'
    | '/registry/permits/$permitId'
    | '/registry/properties/$propertyId'
    | '/registry/rental-contracts/$rentalContractId'
    | '/registry/service-providers/$providerId'
    | '/processes/$processInstanceId/task/$taskId'
    | '/profile/company/representative/$representativeId'
    | '/processes/$processInstanceId/task/$taskId/payment'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/accessibility'
    | '/contact-us'
    | '/faq'
    | '/feedback'
    | '/services'
    | '/sitemap'
    | '/_auth/dashboard'
    | '/_auth/processes'
    | '/_auth/profile'
    | '/_auth/registry'
    | '/services/services-catalogue'
    | '/about-us/'
    | '/accessibility/'
    | '/contact-us/'
    | '/faq/'
    | '/feedback/'
    | '/forgot-password/'
    | '/login/'
    | '/services/'
    | '/signup/'
    | '/sitemap/'
    | '/verify-email/'
    | '/zones/'
    | '/_auth/registry/contracts'
    | '/_auth/registry/permits'
    | '/_auth/registry/properties'
    | '/_auth/registry/rental-contracts'
    | '/_auth/registry/service-providers'
    | '/_auth/dashboard/_layout'
    | '/services/services-catalogue/$id'
    | '/_auth/chat-bot/'
    | '/_auth/logout/'
    | '/_auth/processes/'
    | '/_auth/start-service/'
    | '/_auth/tasks/'
    | '/services/services-catalogue/'
    | '/_auth/dashboard/_layout/contracts'
    | '/_auth/dashboard/_layout/permits'
    | '/_auth/dashboard/_layout/properties'
    | '/_auth/dashboard/_layout/rental-contracts'
    | '/_auth/dashboard/_layout/service-providers'
    | '/_auth/dashboard/_layout/workflows'
    | '/_auth/profile/company/_layout'
    | '/_auth/profile/investor/_layout'
    | '/_auth/dashboard/_layout/'
    | '/_auth/processes/$processInstanceId/'
    | '/_auth/profile/company/_layout/cr-information'
    | '/_auth/profile/company/_layout/notification-settings'
    | '/_auth/profile/company/_layout/representatives'
    | '/_auth/profile/investor/_layout/notification-settings'
    | '/_auth/profile/investor/_layout/personal-information'
    | '/_auth/profile/company/_layout/'
    | '/_auth/profile/investor/_layout/'
    | '/_auth/registry/contracts/$contractId/'
    | '/_auth/registry/permits/$permitId/'
    | '/_auth/registry/properties/$propertyId/'
    | '/_auth/registry/rental-contracts/$rentalContractId/'
    | '/_auth/registry/service-providers/$providerId/'
    | '/_auth/processes/$processInstanceId/task/$taskId/'
    | '/_auth/profile/company/representative/$representativeId/'
    | '/_auth/processes/$processInstanceId/task/$taskId/payment/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AccessibilityRouteRoute: typeof AccessibilityRouteRouteWithChildren
  ContactUsRouteRoute: typeof ContactUsRouteRouteWithChildren
  FaqRouteRoute: typeof FaqRouteRouteWithChildren
  FeedbackRouteRoute: typeof FeedbackRouteRouteWithChildren
  ServicesRouteRoute: typeof ServicesRouteRouteWithChildren
  SitemapRouteRoute: typeof SitemapRouteRouteWithChildren
  AboutUsIndexRoute: typeof AboutUsIndexRoute
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  SignupIndexRoute: typeof SignupIndexRoute
  VerifyEmailIndexRoute: typeof VerifyEmailIndexRoute
  ZonesIndexRoute: typeof ZonesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sitemap': {
      id: '/sitemap'
      path: '/sitemap'
      fullPath: '/sitemap'
      preLoaderRoute: typeof SitemapRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services': {
      id: '/services'
      path: '/services'
      fullPath: '/services'
      preLoaderRoute: typeof ServicesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback': {
      id: '/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof FeedbackRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accessibility': {
      id: '/accessibility'
      path: '/accessibility'
      fullPath: '/accessibility'
      preLoaderRoute: typeof AccessibilityRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/zones/': {
      id: '/zones/'
      path: '/zones'
      fullPath: '/zones/'
      preLoaderRoute: typeof ZonesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email/': {
      id: '/verify-email/'
      path: '/verify-email'
      fullPath: '/verify-email/'
      preLoaderRoute: typeof VerifyEmailIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sitemap/': {
      id: '/sitemap/'
      path: '/'
      fullPath: '/sitemap/'
      preLoaderRoute: typeof SitemapIndexRouteImport
      parentRoute: typeof SitemapRouteRoute
    }
    '/signup/': {
      id: '/signup/'
      path: '/signup'
      fullPath: '/signup/'
      preLoaderRoute: typeof SignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/': {
      id: '/services/'
      path: '/'
      fullPath: '/services/'
      preLoaderRoute: typeof ServicesIndexRouteImport
      parentRoute: typeof ServicesRouteRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password/': {
      id: '/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof ForgotPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feedback/': {
      id: '/feedback/'
      path: '/'
      fullPath: '/feedback/'
      preLoaderRoute: typeof FeedbackIndexRouteImport
      parentRoute: typeof FeedbackRouteRoute
    }
    '/faq/': {
      id: '/faq/'
      path: '/'
      fullPath: '/faq/'
      preLoaderRoute: typeof FaqIndexRouteImport
      parentRoute: typeof FaqRouteRoute
    }
    '/contact-us/': {
      id: '/contact-us/'
      path: '/'
      fullPath: '/contact-us/'
      preLoaderRoute: typeof ContactUsIndexRouteImport
      parentRoute: typeof ContactUsRouteRoute
    }
    '/accessibility/': {
      id: '/accessibility/'
      path: '/'
      fullPath: '/accessibility/'
      preLoaderRoute: typeof AccessibilityIndexRouteImport
      parentRoute: typeof AccessibilityRouteRoute
    }
    '/about-us/': {
      id: '/about-us/'
      path: '/about-us'
      fullPath: '/about-us/'
      preLoaderRoute: typeof AboutUsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/services-catalogue': {
      id: '/services/services-catalogue'
      path: '/services-catalogue'
      fullPath: '/services/services-catalogue'
      preLoaderRoute: typeof ServicesServicesCatalogueRouteRouteImport
      parentRoute: typeof ServicesRouteRoute
    }
    '/_auth/registry': {
      id: '/_auth/registry'
      path: '/registry'
      fullPath: '/registry'
      preLoaderRoute: typeof AuthRegistryRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/profile': {
      id: '/_auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/processes': {
      id: '/_auth/processes'
      path: '/processes'
      fullPath: '/processes'
      preLoaderRoute: typeof AuthProcessesRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/services/services-catalogue/': {
      id: '/services/services-catalogue/'
      path: '/'
      fullPath: '/services/services-catalogue/'
      preLoaderRoute: typeof ServicesServicesCatalogueIndexRouteImport
      parentRoute: typeof ServicesServicesCatalogueRouteRoute
    }
    '/_auth/tasks/': {
      id: '/_auth/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthTasksIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/start-service/': {
      id: '/_auth/start-service/'
      path: '/start-service'
      fullPath: '/start-service/'
      preLoaderRoute: typeof AuthStartServiceIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/processes/': {
      id: '/_auth/processes/'
      path: '/'
      fullPath: '/processes/'
      preLoaderRoute: typeof AuthProcessesIndexRouteImport
      parentRoute: typeof AuthProcessesRouteRoute
    }
    '/_auth/logout/': {
      id: '/_auth/logout/'
      path: '/logout'
      fullPath: '/logout/'
      preLoaderRoute: typeof AuthLogoutIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/chat-bot/': {
      id: '/_auth/chat-bot/'
      path: '/chat-bot'
      fullPath: '/chat-bot/'
      preLoaderRoute: typeof AuthChatBotIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/services/services-catalogue/$id': {
      id: '/services/services-catalogue/$id'
      path: '/$id'
      fullPath: '/services/services-catalogue/$id'
      preLoaderRoute: typeof ServicesServicesCatalogueIdRouteImport
      parentRoute: typeof ServicesServicesCatalogueRouteRoute
    }
    '/_auth/dashboard/_layout': {
      id: '/_auth/dashboard/_layout'
      path: ''
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardLayoutRouteImport
      parentRoute: typeof AuthDashboardRouteRoute
    }
    '/_auth/registry/service-providers': {
      id: '/_auth/registry/service-providers'
      path: '/service-providers'
      fullPath: '/registry/service-providers'
      preLoaderRoute: typeof AuthRegistryServiceProvidersRouteRouteImport
      parentRoute: typeof AuthRegistryRouteRoute
    }
    '/_auth/registry/rental-contracts': {
      id: '/_auth/registry/rental-contracts'
      path: '/rental-contracts'
      fullPath: '/registry/rental-contracts'
      preLoaderRoute: typeof AuthRegistryRentalContractsRouteRouteImport
      parentRoute: typeof AuthRegistryRouteRoute
    }
    '/_auth/registry/properties': {
      id: '/_auth/registry/properties'
      path: '/properties'
      fullPath: '/registry/properties'
      preLoaderRoute: typeof AuthRegistryPropertiesRouteRouteImport
      parentRoute: typeof AuthRegistryRouteRoute
    }
    '/_auth/registry/permits': {
      id: '/_auth/registry/permits'
      path: '/permits'
      fullPath: '/registry/permits'
      preLoaderRoute: typeof AuthRegistryPermitsRouteRouteImport
      parentRoute: typeof AuthRegistryRouteRoute
    }
    '/_auth/registry/contracts': {
      id: '/_auth/registry/contracts'
      path: '/contracts'
      fullPath: '/registry/contracts'
      preLoaderRoute: typeof AuthRegistryContractsRouteRouteImport
      parentRoute: typeof AuthRegistryRouteRoute
    }
    '/_auth/processes/$processInstanceId/': {
      id: '/_auth/processes/$processInstanceId/'
      path: '/$processInstanceId'
      fullPath: '/processes/$processInstanceId/'
      preLoaderRoute: typeof AuthProcessesProcessInstanceIdIndexRouteImport
      parentRoute: typeof AuthProcessesRouteRoute
    }
    '/_auth/dashboard/_layout/': {
      id: '/_auth/dashboard/_layout/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthDashboardLayoutIndexRouteImport
      parentRoute: typeof AuthDashboardLayoutRoute
    }
    '/_auth/profile/investor/_layout': {
      id: '/_auth/profile/investor/_layout'
      path: '/investor'
      fullPath: '/profile/investor'
      preLoaderRoute: typeof AuthProfileInvestorLayoutRouteImport
      parentRoute: typeof AuthProfileRouteRoute
    }
    '/_auth/profile/company/_layout': {
      id: '/_auth/profile/company/_layout'
      path: '/company'
      fullPath: '/profile/company'
      preLoaderRoute: typeof AuthProfileCompanyLayoutRouteImport
      parentRoute: typeof AuthProfileRouteRoute
    }
    '/_auth/dashboard/_layout/workflows': {
      id: '/_auth/dashboard/_layout/workflows'
      path: '/workflows'
      fullPath: '/dashboard/workflows'
      preLoaderRoute: typeof AuthDashboardLayoutWorkflowsRouteImport
      parentRoute: typeof AuthDashboardLayoutRoute
    }
    '/_auth/dashboard/_layout/service-providers': {
      id: '/_auth/dashboard/_layout/service-providers'
      path: '/service-providers'
      fullPath: '/dashboard/service-providers'
      preLoaderRoute: typeof AuthDashboardLayoutServiceProvidersRouteImport
      parentRoute: typeof AuthDashboardLayoutRoute
    }
    '/_auth/dashboard/_layout/rental-contracts': {
      id: '/_auth/dashboard/_layout/rental-contracts'
      path: '/rental-contracts'
      fullPath: '/dashboard/rental-contracts'
      preLoaderRoute: typeof AuthDashboardLayoutRentalContractsRouteImport
      parentRoute: typeof AuthDashboardLayoutRoute
    }
    '/_auth/dashboard/_layout/properties': {
      id: '/_auth/dashboard/_layout/properties'
      path: '/properties'
      fullPath: '/dashboard/properties'
      preLoaderRoute: typeof AuthDashboardLayoutPropertiesRouteImport
      parentRoute: typeof AuthDashboardLayoutRoute
    }
    '/_auth/dashboard/_layout/permits': {
      id: '/_auth/dashboard/_layout/permits'
      path: '/permits'
      fullPath: '/dashboard/permits'
      preLoaderRoute: typeof AuthDashboardLayoutPermitsRouteImport
      parentRoute: typeof AuthDashboardLayoutRoute
    }
    '/_auth/dashboard/_layout/contracts': {
      id: '/_auth/dashboard/_layout/contracts'
      path: '/contracts'
      fullPath: '/dashboard/contracts'
      preLoaderRoute: typeof AuthDashboardLayoutContractsRouteImport
      parentRoute: typeof AuthDashboardLayoutRoute
    }
    '/_auth/registry/service-providers/$providerId/': {
      id: '/_auth/registry/service-providers/$providerId/'
      path: '/$providerId'
      fullPath: '/registry/service-providers/$providerId/'
      preLoaderRoute: typeof AuthRegistryServiceProvidersProviderIdIndexRouteImport
      parentRoute: typeof AuthRegistryServiceProvidersRouteRoute
    }
    '/_auth/registry/rental-contracts/$rentalContractId/': {
      id: '/_auth/registry/rental-contracts/$rentalContractId/'
      path: '/$rentalContractId'
      fullPath: '/registry/rental-contracts/$rentalContractId/'
      preLoaderRoute: typeof AuthRegistryRentalContractsRentalContractIdIndexRouteImport
      parentRoute: typeof AuthRegistryRentalContractsRouteRoute
    }
    '/_auth/registry/properties/$propertyId/': {
      id: '/_auth/registry/properties/$propertyId/'
      path: '/$propertyId'
      fullPath: '/registry/properties/$propertyId/'
      preLoaderRoute: typeof AuthRegistryPropertiesPropertyIdIndexRouteImport
      parentRoute: typeof AuthRegistryPropertiesRouteRoute
    }
    '/_auth/registry/permits/$permitId/': {
      id: '/_auth/registry/permits/$permitId/'
      path: '/$permitId'
      fullPath: '/registry/permits/$permitId/'
      preLoaderRoute: typeof AuthRegistryPermitsPermitIdIndexRouteImport
      parentRoute: typeof AuthRegistryPermitsRouteRoute
    }
    '/_auth/registry/contracts/$contractId/': {
      id: '/_auth/registry/contracts/$contractId/'
      path: '/$contractId'
      fullPath: '/registry/contracts/$contractId/'
      preLoaderRoute: typeof AuthRegistryContractsContractIdIndexRouteImport
      parentRoute: typeof AuthRegistryContractsRouteRoute
    }
    '/_auth/profile/investor/_layout/': {
      id: '/_auth/profile/investor/_layout/'
      path: '/'
      fullPath: '/profile/investor/'
      preLoaderRoute: typeof AuthProfileInvestorLayoutIndexRouteImport
      parentRoute: typeof AuthProfileInvestorLayoutRoute
    }
    '/_auth/profile/company/_layout/': {
      id: '/_auth/profile/company/_layout/'
      path: '/'
      fullPath: '/profile/company/'
      preLoaderRoute: typeof AuthProfileCompanyLayoutIndexRouteImport
      parentRoute: typeof AuthProfileCompanyLayoutRoute
    }
    '/_auth/profile/investor/_layout/personal-information': {
      id: '/_auth/profile/investor/_layout/personal-information'
      path: '/personal-information'
      fullPath: '/profile/investor/personal-information'
      preLoaderRoute: typeof AuthProfileInvestorLayoutPersonalInformationRouteImport
      parentRoute: typeof AuthProfileInvestorLayoutRoute
    }
    '/_auth/profile/investor/_layout/notification-settings': {
      id: '/_auth/profile/investor/_layout/notification-settings'
      path: '/notification-settings'
      fullPath: '/profile/investor/notification-settings'
      preLoaderRoute: typeof AuthProfileInvestorLayoutNotificationSettingsRouteImport
      parentRoute: typeof AuthProfileInvestorLayoutRoute
    }
    '/_auth/profile/company/_layout/representatives': {
      id: '/_auth/profile/company/_layout/representatives'
      path: '/representatives'
      fullPath: '/profile/company/representatives'
      preLoaderRoute: typeof AuthProfileCompanyLayoutRepresentativesRouteImport
      parentRoute: typeof AuthProfileCompanyLayoutRoute
    }
    '/_auth/profile/company/_layout/notification-settings': {
      id: '/_auth/profile/company/_layout/notification-settings'
      path: '/notification-settings'
      fullPath: '/profile/company/notification-settings'
      preLoaderRoute: typeof AuthProfileCompanyLayoutNotificationSettingsRouteImport
      parentRoute: typeof AuthProfileCompanyLayoutRoute
    }
    '/_auth/profile/company/_layout/cr-information': {
      id: '/_auth/profile/company/_layout/cr-information'
      path: '/cr-information'
      fullPath: '/profile/company/cr-information'
      preLoaderRoute: typeof AuthProfileCompanyLayoutCrInformationRouteImport
      parentRoute: typeof AuthProfileCompanyLayoutRoute
    }
    '/_auth/profile/company/representative/$representativeId/': {
      id: '/_auth/profile/company/representative/$representativeId/'
      path: '/company/representative/$representativeId'
      fullPath: '/profile/company/representative/$representativeId/'
      preLoaderRoute: typeof AuthProfileCompanyRepresentativeRepresentativeIdIndexRouteImport
      parentRoute: typeof AuthProfileRouteRoute
    }
    '/_auth/processes/$processInstanceId/task/$taskId/': {
      id: '/_auth/processes/$processInstanceId/task/$taskId/'
      path: '/$processInstanceId/task/$taskId'
      fullPath: '/processes/$processInstanceId/task/$taskId/'
      preLoaderRoute: typeof AuthProcessesProcessInstanceIdTaskTaskIdIndexRouteImport
      parentRoute: typeof AuthProcessesRouteRoute
    }
    '/_auth/processes/$processInstanceId/task/$taskId/payment/': {
      id: '/_auth/processes/$processInstanceId/task/$taskId/payment/'
      path: '/$processInstanceId/task/$taskId/payment'
      fullPath: '/processes/$processInstanceId/task/$taskId/payment/'
      preLoaderRoute: typeof AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRouteImport
      parentRoute: typeof AuthProcessesRouteRoute
    }
  }
}

interface AuthDashboardLayoutRouteChildren {
  AuthDashboardLayoutContractsRoute: typeof AuthDashboardLayoutContractsRoute
  AuthDashboardLayoutPermitsRoute: typeof AuthDashboardLayoutPermitsRoute
  AuthDashboardLayoutPropertiesRoute: typeof AuthDashboardLayoutPropertiesRoute
  AuthDashboardLayoutRentalContractsRoute: typeof AuthDashboardLayoutRentalContractsRoute
  AuthDashboardLayoutServiceProvidersRoute: typeof AuthDashboardLayoutServiceProvidersRoute
  AuthDashboardLayoutWorkflowsRoute: typeof AuthDashboardLayoutWorkflowsRoute
  AuthDashboardLayoutIndexRoute: typeof AuthDashboardLayoutIndexRoute
}

const AuthDashboardLayoutRouteChildren: AuthDashboardLayoutRouteChildren = {
  AuthDashboardLayoutContractsRoute: AuthDashboardLayoutContractsRoute,
  AuthDashboardLayoutPermitsRoute: AuthDashboardLayoutPermitsRoute,
  AuthDashboardLayoutPropertiesRoute: AuthDashboardLayoutPropertiesRoute,
  AuthDashboardLayoutRentalContractsRoute:
    AuthDashboardLayoutRentalContractsRoute,
  AuthDashboardLayoutServiceProvidersRoute:
    AuthDashboardLayoutServiceProvidersRoute,
  AuthDashboardLayoutWorkflowsRoute: AuthDashboardLayoutWorkflowsRoute,
  AuthDashboardLayoutIndexRoute: AuthDashboardLayoutIndexRoute,
}

const AuthDashboardLayoutRouteWithChildren =
  AuthDashboardLayoutRoute._addFileChildren(AuthDashboardLayoutRouteChildren)

interface AuthDashboardRouteRouteChildren {
  AuthDashboardLayoutRoute: typeof AuthDashboardLayoutRouteWithChildren
}

const AuthDashboardRouteRouteChildren: AuthDashboardRouteRouteChildren = {
  AuthDashboardLayoutRoute: AuthDashboardLayoutRouteWithChildren,
}

const AuthDashboardRouteRouteWithChildren =
  AuthDashboardRouteRoute._addFileChildren(AuthDashboardRouteRouteChildren)

interface AuthProcessesRouteRouteChildren {
  AuthProcessesIndexRoute: typeof AuthProcessesIndexRoute
  AuthProcessesProcessInstanceIdIndexRoute: typeof AuthProcessesProcessInstanceIdIndexRoute
  AuthProcessesProcessInstanceIdTaskTaskIdIndexRoute: typeof AuthProcessesProcessInstanceIdTaskTaskIdIndexRoute
  AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRoute: typeof AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRoute
}

const AuthProcessesRouteRouteChildren: AuthProcessesRouteRouteChildren = {
  AuthProcessesIndexRoute: AuthProcessesIndexRoute,
  AuthProcessesProcessInstanceIdIndexRoute:
    AuthProcessesProcessInstanceIdIndexRoute,
  AuthProcessesProcessInstanceIdTaskTaskIdIndexRoute:
    AuthProcessesProcessInstanceIdTaskTaskIdIndexRoute,
  AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRoute:
    AuthProcessesProcessInstanceIdTaskTaskIdPaymentIndexRoute,
}

const AuthProcessesRouteRouteWithChildren =
  AuthProcessesRouteRoute._addFileChildren(AuthProcessesRouteRouteChildren)

interface AuthProfileCompanyLayoutRouteChildren {
  AuthProfileCompanyLayoutCrInformationRoute: typeof AuthProfileCompanyLayoutCrInformationRoute
  AuthProfileCompanyLayoutNotificationSettingsRoute: typeof AuthProfileCompanyLayoutNotificationSettingsRoute
  AuthProfileCompanyLayoutRepresentativesRoute: typeof AuthProfileCompanyLayoutRepresentativesRoute
  AuthProfileCompanyLayoutIndexRoute: typeof AuthProfileCompanyLayoutIndexRoute
}

const AuthProfileCompanyLayoutRouteChildren: AuthProfileCompanyLayoutRouteChildren =
  {
    AuthProfileCompanyLayoutCrInformationRoute:
      AuthProfileCompanyLayoutCrInformationRoute,
    AuthProfileCompanyLayoutNotificationSettingsRoute:
      AuthProfileCompanyLayoutNotificationSettingsRoute,
    AuthProfileCompanyLayoutRepresentativesRoute:
      AuthProfileCompanyLayoutRepresentativesRoute,
    AuthProfileCompanyLayoutIndexRoute: AuthProfileCompanyLayoutIndexRoute,
  }

const AuthProfileCompanyLayoutRouteWithChildren =
  AuthProfileCompanyLayoutRoute._addFileChildren(
    AuthProfileCompanyLayoutRouteChildren,
  )

interface AuthProfileInvestorLayoutRouteChildren {
  AuthProfileInvestorLayoutNotificationSettingsRoute: typeof AuthProfileInvestorLayoutNotificationSettingsRoute
  AuthProfileInvestorLayoutPersonalInformationRoute: typeof AuthProfileInvestorLayoutPersonalInformationRoute
  AuthProfileInvestorLayoutIndexRoute: typeof AuthProfileInvestorLayoutIndexRoute
}

const AuthProfileInvestorLayoutRouteChildren: AuthProfileInvestorLayoutRouteChildren =
  {
    AuthProfileInvestorLayoutNotificationSettingsRoute:
      AuthProfileInvestorLayoutNotificationSettingsRoute,
    AuthProfileInvestorLayoutPersonalInformationRoute:
      AuthProfileInvestorLayoutPersonalInformationRoute,
    AuthProfileInvestorLayoutIndexRoute: AuthProfileInvestorLayoutIndexRoute,
  }

const AuthProfileInvestorLayoutRouteWithChildren =
  AuthProfileInvestorLayoutRoute._addFileChildren(
    AuthProfileInvestorLayoutRouteChildren,
  )

interface AuthProfileRouteRouteChildren {
  AuthProfileCompanyLayoutRoute: typeof AuthProfileCompanyLayoutRouteWithChildren
  AuthProfileInvestorLayoutRoute: typeof AuthProfileInvestorLayoutRouteWithChildren
  AuthProfileCompanyRepresentativeRepresentativeIdIndexRoute: typeof AuthProfileCompanyRepresentativeRepresentativeIdIndexRoute
}

const AuthProfileRouteRouteChildren: AuthProfileRouteRouteChildren = {
  AuthProfileCompanyLayoutRoute: AuthProfileCompanyLayoutRouteWithChildren,
  AuthProfileInvestorLayoutRoute: AuthProfileInvestorLayoutRouteWithChildren,
  AuthProfileCompanyRepresentativeRepresentativeIdIndexRoute:
    AuthProfileCompanyRepresentativeRepresentativeIdIndexRoute,
}

const AuthProfileRouteRouteWithChildren =
  AuthProfileRouteRoute._addFileChildren(AuthProfileRouteRouteChildren)

interface AuthRegistryContractsRouteRouteChildren {
  AuthRegistryContractsContractIdIndexRoute: typeof AuthRegistryContractsContractIdIndexRoute
}

const AuthRegistryContractsRouteRouteChildren: AuthRegistryContractsRouteRouteChildren =
  {
    AuthRegistryContractsContractIdIndexRoute:
      AuthRegistryContractsContractIdIndexRoute,
  }

const AuthRegistryContractsRouteRouteWithChildren =
  AuthRegistryContractsRouteRoute._addFileChildren(
    AuthRegistryContractsRouteRouteChildren,
  )

interface AuthRegistryPermitsRouteRouteChildren {
  AuthRegistryPermitsPermitIdIndexRoute: typeof AuthRegistryPermitsPermitIdIndexRoute
}

const AuthRegistryPermitsRouteRouteChildren: AuthRegistryPermitsRouteRouteChildren =
  {
    AuthRegistryPermitsPermitIdIndexRoute:
      AuthRegistryPermitsPermitIdIndexRoute,
  }

const AuthRegistryPermitsRouteRouteWithChildren =
  AuthRegistryPermitsRouteRoute._addFileChildren(
    AuthRegistryPermitsRouteRouteChildren,
  )

interface AuthRegistryPropertiesRouteRouteChildren {
  AuthRegistryPropertiesPropertyIdIndexRoute: typeof AuthRegistryPropertiesPropertyIdIndexRoute
}

const AuthRegistryPropertiesRouteRouteChildren: AuthRegistryPropertiesRouteRouteChildren =
  {
    AuthRegistryPropertiesPropertyIdIndexRoute:
      AuthRegistryPropertiesPropertyIdIndexRoute,
  }

const AuthRegistryPropertiesRouteRouteWithChildren =
  AuthRegistryPropertiesRouteRoute._addFileChildren(
    AuthRegistryPropertiesRouteRouteChildren,
  )

interface AuthRegistryRentalContractsRouteRouteChildren {
  AuthRegistryRentalContractsRentalContractIdIndexRoute: typeof AuthRegistryRentalContractsRentalContractIdIndexRoute
}

const AuthRegistryRentalContractsRouteRouteChildren: AuthRegistryRentalContractsRouteRouteChildren =
  {
    AuthRegistryRentalContractsRentalContractIdIndexRoute:
      AuthRegistryRentalContractsRentalContractIdIndexRoute,
  }

const AuthRegistryRentalContractsRouteRouteWithChildren =
  AuthRegistryRentalContractsRouteRoute._addFileChildren(
    AuthRegistryRentalContractsRouteRouteChildren,
  )

interface AuthRegistryServiceProvidersRouteRouteChildren {
  AuthRegistryServiceProvidersProviderIdIndexRoute: typeof AuthRegistryServiceProvidersProviderIdIndexRoute
}

const AuthRegistryServiceProvidersRouteRouteChildren: AuthRegistryServiceProvidersRouteRouteChildren =
  {
    AuthRegistryServiceProvidersProviderIdIndexRoute:
      AuthRegistryServiceProvidersProviderIdIndexRoute,
  }

const AuthRegistryServiceProvidersRouteRouteWithChildren =
  AuthRegistryServiceProvidersRouteRoute._addFileChildren(
    AuthRegistryServiceProvidersRouteRouteChildren,
  )

interface AuthRegistryRouteRouteChildren {
  AuthRegistryContractsRouteRoute: typeof AuthRegistryContractsRouteRouteWithChildren
  AuthRegistryPermitsRouteRoute: typeof AuthRegistryPermitsRouteRouteWithChildren
  AuthRegistryPropertiesRouteRoute: typeof AuthRegistryPropertiesRouteRouteWithChildren
  AuthRegistryRentalContractsRouteRoute: typeof AuthRegistryRentalContractsRouteRouteWithChildren
  AuthRegistryServiceProvidersRouteRoute: typeof AuthRegistryServiceProvidersRouteRouteWithChildren
}

const AuthRegistryRouteRouteChildren: AuthRegistryRouteRouteChildren = {
  AuthRegistryContractsRouteRoute: AuthRegistryContractsRouteRouteWithChildren,
  AuthRegistryPermitsRouteRoute: AuthRegistryPermitsRouteRouteWithChildren,
  AuthRegistryPropertiesRouteRoute:
    AuthRegistryPropertiesRouteRouteWithChildren,
  AuthRegistryRentalContractsRouteRoute:
    AuthRegistryRentalContractsRouteRouteWithChildren,
  AuthRegistryServiceProvidersRouteRoute:
    AuthRegistryServiceProvidersRouteRouteWithChildren,
}

const AuthRegistryRouteRouteWithChildren =
  AuthRegistryRouteRoute._addFileChildren(AuthRegistryRouteRouteChildren)

interface AuthRouteRouteChildren {
  AuthDashboardRouteRoute: typeof AuthDashboardRouteRouteWithChildren
  AuthProcessesRouteRoute: typeof AuthProcessesRouteRouteWithChildren
  AuthProfileRouteRoute: typeof AuthProfileRouteRouteWithChildren
  AuthRegistryRouteRoute: typeof AuthRegistryRouteRouteWithChildren
  AuthChatBotIndexRoute: typeof AuthChatBotIndexRoute
  AuthLogoutIndexRoute: typeof AuthLogoutIndexRoute
  AuthStartServiceIndexRoute: typeof AuthStartServiceIndexRoute
  AuthTasksIndexRoute: typeof AuthTasksIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthDashboardRouteRoute: AuthDashboardRouteRouteWithChildren,
  AuthProcessesRouteRoute: AuthProcessesRouteRouteWithChildren,
  AuthProfileRouteRoute: AuthProfileRouteRouteWithChildren,
  AuthRegistryRouteRoute: AuthRegistryRouteRouteWithChildren,
  AuthChatBotIndexRoute: AuthChatBotIndexRoute,
  AuthLogoutIndexRoute: AuthLogoutIndexRoute,
  AuthStartServiceIndexRoute: AuthStartServiceIndexRoute,
  AuthTasksIndexRoute: AuthTasksIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AccessibilityRouteRouteChildren {
  AccessibilityIndexRoute: typeof AccessibilityIndexRoute
}

const AccessibilityRouteRouteChildren: AccessibilityRouteRouteChildren = {
  AccessibilityIndexRoute: AccessibilityIndexRoute,
}

const AccessibilityRouteRouteWithChildren =
  AccessibilityRouteRoute._addFileChildren(AccessibilityRouteRouteChildren)

interface ContactUsRouteRouteChildren {
  ContactUsIndexRoute: typeof ContactUsIndexRoute
}

const ContactUsRouteRouteChildren: ContactUsRouteRouteChildren = {
  ContactUsIndexRoute: ContactUsIndexRoute,
}

const ContactUsRouteRouteWithChildren = ContactUsRouteRoute._addFileChildren(
  ContactUsRouteRouteChildren,
)

interface FaqRouteRouteChildren {
  FaqIndexRoute: typeof FaqIndexRoute
}

const FaqRouteRouteChildren: FaqRouteRouteChildren = {
  FaqIndexRoute: FaqIndexRoute,
}

const FaqRouteRouteWithChildren = FaqRouteRoute._addFileChildren(
  FaqRouteRouteChildren,
)

interface FeedbackRouteRouteChildren {
  FeedbackIndexRoute: typeof FeedbackIndexRoute
}

const FeedbackRouteRouteChildren: FeedbackRouteRouteChildren = {
  FeedbackIndexRoute: FeedbackIndexRoute,
}

const FeedbackRouteRouteWithChildren = FeedbackRouteRoute._addFileChildren(
  FeedbackRouteRouteChildren,
)

interface ServicesServicesCatalogueRouteRouteChildren {
  ServicesServicesCatalogueIdRoute: typeof ServicesServicesCatalogueIdRoute
  ServicesServicesCatalogueIndexRoute: typeof ServicesServicesCatalogueIndexRoute
}

const ServicesServicesCatalogueRouteRouteChildren: ServicesServicesCatalogueRouteRouteChildren =
  {
    ServicesServicesCatalogueIdRoute: ServicesServicesCatalogueIdRoute,
    ServicesServicesCatalogueIndexRoute: ServicesServicesCatalogueIndexRoute,
  }

const ServicesServicesCatalogueRouteRouteWithChildren =
  ServicesServicesCatalogueRouteRoute._addFileChildren(
    ServicesServicesCatalogueRouteRouteChildren,
  )

interface ServicesRouteRouteChildren {
  ServicesServicesCatalogueRouteRoute: typeof ServicesServicesCatalogueRouteRouteWithChildren
  ServicesIndexRoute: typeof ServicesIndexRoute
}

const ServicesRouteRouteChildren: ServicesRouteRouteChildren = {
  ServicesServicesCatalogueRouteRoute:
    ServicesServicesCatalogueRouteRouteWithChildren,
  ServicesIndexRoute: ServicesIndexRoute,
}

const ServicesRouteRouteWithChildren = ServicesRouteRoute._addFileChildren(
  ServicesRouteRouteChildren,
)

interface SitemapRouteRouteChildren {
  SitemapIndexRoute: typeof SitemapIndexRoute
}

const SitemapRouteRouteChildren: SitemapRouteRouteChildren = {
  SitemapIndexRoute: SitemapIndexRoute,
}

const SitemapRouteRouteWithChildren = SitemapRouteRoute._addFileChildren(
  SitemapRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AccessibilityRouteRoute: AccessibilityRouteRouteWithChildren,
  ContactUsRouteRoute: ContactUsRouteRouteWithChildren,
  FaqRouteRoute: FaqRouteRouteWithChildren,
  FeedbackRouteRoute: FeedbackRouteRouteWithChildren,
  ServicesRouteRoute: ServicesRouteRouteWithChildren,
  SitemapRouteRoute: SitemapRouteRouteWithChildren,
  AboutUsIndexRoute: AboutUsIndexRoute,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  SignupIndexRoute: SignupIndexRoute,
  VerifyEmailIndexRoute: VerifyEmailIndexRoute,
  ZonesIndexRoute: ZonesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
